import { render, staticRenderFns } from "./MenuLavori.vue?vue&type=template&id=f28cf95c&scoped=true&"
import script from "./MenuLavori.vue?vue&type=script&lang=js&"
export * from "./MenuLavori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28cf95c",
  null
  
)

export default component.exports